import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Validators } from '@angular/forms';
import { TypedFormControl, TypedFormGroup } from '@principle-theorem/ng-shared';
import {
  AccBooleanValue,
  AccCariesActivity,
  AccCondition,
  AccToothNumber,
  IAccDentalInjuryOther,
} from '@principle-theorem/principle-core/interfaces';
import { filterUndefined } from '@principle-theorem/shared';
import { hasRequiredError, setRequiredValidation } from './form-group-helpers';

export class AccDentalInjuryOtherFormGroup extends TypedFormGroup<IAccDentalInjuryOther> {
  constructor() {
    super({
      permanentTeethMissingPriorToAccident:
        new TypedFormControl<AccBooleanValue>(undefined, Validators.required),
      teethMissing: new TypedFormControl<AccToothNumber[]>([]),
      oralHygiene: new TypedFormControl<AccCondition>(
        undefined,
        Validators.required
      ),
      periodontalCondition: new TypedFormControl<AccCondition>(
        undefined,
        Validators.required
      ),
      cariesActivityInMouth: new TypedFormControl<AccCariesActivity>(
        undefined,
        Validators.required
      ),
      radiographsTaken: new TypedFormControl<AccBooleanValue>(
        undefined,
        Validators.required
      ),
      radiographsType: new TypedFormControl<string>(
        undefined,
        Validators.maxLength(100)
      ),
      photographicRecordOfInjury: new TypedFormControl<AccBooleanValue>(
        undefined,
        Validators.required
      ),
    });

    this._setupValidationHandlers();
  }

  get permanentTeethMissingPriorToAccidentRequiredError(): boolean {
    return hasRequiredError(this.controls.permanentTeethMissingPriorToAccident);
  }

  get teethMissingRequiredError(): boolean {
    return hasRequiredError(this.controls.teethMissing);
  }

  get oralHygieneRequiredError(): boolean {
    return hasRequiredError(this.controls.oralHygiene);
  }

  get periodontalConditionRequiredError(): boolean {
    return hasRequiredError(this.controls.periodontalCondition);
  }

  get cariesActivityInMouthRequiredError(): boolean {
    return hasRequiredError(this.controls.cariesActivityInMouth);
  }

  get radiographsTakenRequiredError(): boolean {
    return hasRequiredError(this.controls.radiographsTaken);
  }

  get radiographsTypeRequiredError(): boolean {
    return hasRequiredError(this.controls.radiographsType);
  }

  get photographicRecordOfInjuryRequiredError(): boolean {
    return hasRequiredError(this.controls.photographicRecordOfInjury);
  }

  get displayTeethMissing(): boolean {
    return (
      this.controls.permanentTeethMissingPriorToAccident.value ===
      AccBooleanValue.True
    );
  }

  get displayRadiographsTaken(): boolean {
    return this.controls.radiographsTaken.value === AccBooleanValue.True;
  }

  private _setupValidationHandlers(): void {
    // teethMissing is required when permanentTeethMissingPriorToAccident is true
    this.controls.permanentTeethMissingPriorToAccident.valueChanges
      .pipe(filterUndefined(), takeUntilDestroyed())
      .subscribe((value) =>
        setRequiredValidation(value, this.controls.teethMissing, [])
      );

    // radiographsType is required when radiographsTaken is true
    this.controls.radiographsTaken.valueChanges
      .pipe(filterUndefined(), takeUntilDestroyed())
      .subscribe((value) =>
        setRequiredValidation(value, this.controls.radiographsType, undefined, [
          Validators.maxLength(100),
        ])
      );
  }
}
